<template>
  <div class="h-pm-gnb-dataQuery-tree">
    <ejs-treeview ref='gnbPmDataQueryTree' :fields='fieldsOfGnbPmDataQueryTree' :nodeSelected="nodeSelectedOfGnbPmDataQueryTree"></ejs-treeview>
  </div>
</template>

<script>

export default {
  name: 'PmNoRealDataQueryLeftTree',
  components: {
  },
  data() {
    return {
      fieldsOfGnbPmDataQueryTree: {
        dataSource: [],
        id: 'id',
        parentID: 'parentId',
        text: 'name',
        hasChildren: 'hasChildren',
        expanded: 'expanded'
      }
    }
  },
  methods: {

    nodeSelectedOfGnbPmDataQueryTree(args){
      const params = this.$refs.gnbPmDataQueryTree.getTreeData(args.nodeData.id)[0];
      this.$emit('gnbPmDataQueryTreeClickEventPush', params);
    },

    initGnbPmDataQueryTree(){
      this.$axios.get('/lte/ems/pm/gnb/query/getGnbPmDataQueryTree.html').then((response) => {
        this.fieldsOfGnbPmDataQueryTree = {
          dataSource: response.data.resultVal,
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        };
      });
    }
  },
  mounted() {
    this.initGnbPmDataQueryTree();
  }
};
</script>

<style>

</style>
